import {Injectable} from '@angular/core';

@Injectable()
export class DetectBrowserService {

  constructor() {
  }

  isBrowserCompatible(): boolean {
    /*
    navigator.userAgent renvoie constamment un resultat qui inclus les mots Safari et Mozilla.
    Si le navigateur est un fork de chrome, le mot apparaitra aussi.
    Il faut donc isoler le nom des autres navigateurs qui posent problème.
    ex:
    - EdgA --> Edge mobile (basé sur Chrome, fonctionnel)
    - Edge --> Edge PC, a bloquer
    - SamsungBrowser --> Samsung Internet Browser, impossible de tourné la caméra
    - Firefox --> ne pas bloquer
    - Chrome --> ne pas bloquer
     */
    return navigator.userAgent.search(/(?:SamsungBrowser|Edge)/) === -1;
  }

  detectIphone(): boolean {
    return !(navigator.userAgent.search(/(?:iPhone|iPad)/) === -1);

  }

}



// WEBPACK FOOTER //
// ./src/app/detect-browser.service.ts